import { combineReducers } from 'redux';
import app from './app';
import templateLibraryReducer from './templateReducer';
import v2DashboardReducer from './v2DashboardReducer';

export default combineReducers({
  appReducers: app,
  templateLibrary: templateLibraryReducer,
  v2Dashboard: v2DashboardReducer,
});
